import {
  textUI,
  titleUI,
  currentOrPastDateUI,
  currentOrPastDateSchema,
  selectUI,
  checkboxUI,
  checkboxSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  STATE_VALUES,
  STATE_NAMES,
  COUNTRY_VALUES,
  COUNTRY_NAMES,
} from '../../../../utils/labels';
import { customAddressSchema } from '../../../../config/definitions';
import { validations } from '../../../../config/validations';
import content from '../../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-veteran-marriage-location-title']),
    marriageToVeteranStartDate: currentOrPastDateUI({
      title: content['household-veteran-marriage-location-start-date'],
      validations: [validations.isBeforeVeteranDeathDate],
    }),
    marriageToVeteranStartOutsideUs: checkboxUI({
      title: content['household-veteran-marriage-location-outside-us'],
    }),
    marriageToVeteranStartLocation: {
      city: {
        ...textUI(content['address-city']),
        'ui:errorMessages': {
          required: content['address-city-error'],
        },
      },
      state: {
        ...selectUI(content['address-state']),
        'ui:required': formData => !formData?.marriageToVeteranStartOutsideUs,
        'ui:options': {
          hideIf: formData => formData?.marriageToVeteranStartOutsideUs,
          labels: STATE_VALUES.reduce((acc, value, idx) => {
            acc[value] = STATE_NAMES[idx];
            return acc;
          }, {}),
        },
        'ui:errorMessages': {
          required: content['address-state-error'],
        },
      },
      otherCountry: {
        ...selectUI(content['address-country']),
        'ui:required': formData => formData?.marriageToVeteranStartOutsideUs,
        'ui:options': {
          hideIf: formData => !formData?.marriageToVeteranStartOutsideUs,
          labels: COUNTRY_VALUES.reduce((acc, value, idx) => {
            acc[value] = COUNTRY_NAMES[idx];
            return acc;
          }, {}),
        },
        'ui:errorMessages': {
          required: content['address-country-error'],
        },
      },
    },
  },
  schema: {
    type: 'object',
    required: ['marriageToVeteranStartDate', 'marriageToVeteranStartLocation'],
    properties: {
      marriageToVeteranStartDate: currentOrPastDateSchema,
      marriageToVeteranStartOutsideUs: checkboxSchema,
      marriageToVeteranStartLocation: customAddressSchema,
    },
  },
};
